module.exports = __webpack_public_path__ + "static/media/img1-4.5697a929.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/nogal/biosense/diff/img1-4.png
// module id = 1894
// module chunks = 3